import { SOCIAL_POST_PLATFORMS } from './platforms';

export type { SocialPostPlatformId } from './platforms';

function hostMatchesDomain(hostname: string, domain: string): boolean {
	return hostname === domain || hostname.endsWith(`.${domain}`);
}

/** The allowlisted platform for a hostname, or undefined when the site isn't supported. */
export function matchAllowlistedPlatform(hostname: string): (typeof SOCIAL_POST_PLATFORMS)[number] | undefined {
	const host = hostname.toLowerCase();
	return SOCIAL_POST_PLATFORMS.find((platform) => platform.domains.some((domain) => hostMatchesDomain(host, domain)));
}

/** The platform's primary apex domain, as shown to the user when the source has no name of its own. */
export function platformDomain(id: (typeof SOCIAL_POST_PLATFORMS)[number]['id']): string {
	const platform = SOCIAL_POST_PLATFORMS.find((candidate) => candidate.id === id);
	return platform ? platform.domains[0] : id;
}
